// FILE: src/components/studyplan/LogisticsChecklist.js
//
// Right-rail "Exam Logistics" checklist (learner_prep_tasks-backed,
// self-attested) + the single rule-based "Next up" recommendation.

import React, { useState } from 'react';
import styles from './StudyPlanViewPage.module.css';
import { setLogisticsDone } from '../../services/examLogisticsService';

export default function LogisticsChecklist({ examId, logistics, nextRisk, onLogisticsChange }) {
  const done = logistics.filter((t) => t.completed).length;
  return (
    <div className={styles.railCard} data-testid="study-plan-view-logistics">
      <div className={styles.railHead}>
        Exam Logistics <span className={styles.railHeadCount}>{done} of {logistics.length}</span>
      </div>
      {logistics.map((t) => (
        <LogRow key={t.key} task={t} examId={examId} onLogisticsChange={onLogisticsChange} />
      ))}
      {nextRisk ? (
        <div className={styles.risk} data-testid="study-plan-view-next-risk">
          <b>Next up</b>{nextRisk}
        </div>
      ) : null}
    </div>
  );
}

function LogRow({ task, examId, onLogisticsChange }) {
  const [busy, setBusy] = useState(false);
  async function toggle() {
    setBusy(true);
    const ok = await setLogisticsDone(task.key, examId, !task.completed);
    setBusy(false);
    if (ok) onLogisticsChange?.(task.key, !task.completed);
  }
  return (
    <div className={`${styles.logItem} ${task.overdue ? styles.logOverdue : ''}`} data-testid={`logistics-${task.key}`}>
      <button
        type="button"
        className={`${styles.markBtn} ${task.completed ? styles.markDone : ''}`}
        onClick={toggle}
        disabled={busy}
        title={task.completed ? 'Mark not done' : 'Mark done'}
      >{task.completed ? '✓' : ''}</button>
      <div className={styles.logBody}>
        {task.title}
        {(task.sub || task.dueDate) ? (
          <span className={styles.logSub}>
            {task.sub}{task.sub && task.dueDate ? ' · ' : ''}{task.dueDate ? `recommended by ${task.dueDate}` : ''}
          </span>
        ) : null}
      </div>
      {task.when ? <span className={styles.infoTag}>{task.when}</span> : null}
    </div>
  );
}
